// src/sections/jobFest/JobFestFinalCta.tsx
import React from "react";

export const JobFestFinalCta: React.FC = () => {
  return (
    <section className="jobfest-final-cta" id="jobfest-final-cta">
      <div className="jobfest-final-cta-inner">
        <h2 className="jobfest-final-cta-title">
          Ready to Transform Your Hiring?
        </h2>

        <p className="jobfest-final-cta-subtitle">
          Join the December cohort and access India&apos;s top 5% AI talent.
        </p>

        {/* Link this to your employer card or booking flow */}
        <a href="https://calendly.com/sales-babblebots/babblebots-discovery" className="jobfest-final-cta-btn">
          Connect with us
        </a>
      </div>
    </section>
  );
};
